// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  aarKey: __t.string().primaryKey().name("aar_key"),
  campaignId: __t.u64().name("campaign_id"),
  cyc: __t.u64(),
  generation: __t.u32(),
  rulesVersion: __t.u32().name("rules_version"),
  winner: __t.string(),
  retreatSide: __t.i32().name("retreat_side"),
  fortKey: __t.string().name("fort_key"),
  targetSystem: __t.string().name("target_system"),
  openedAt: __t.timestamp().name("opened_at"),
  endsAt: __t.timestamp().name("ends_at"),
  settledAt: __t.timestamp().name("settled_at"),
  summary: __t.string(),
  checksum: __t.string(),
  sandbox: __t.bool(),
});
